export default class EnumeratorBase {
    next( /*...args: []*/) {
        //args.length;
        const done = !this.moveNext();
        const value = done ? undefined : this.current;
        return { done, value: value };
    }
}
